import axios from 'axios';

export default {
    methods: {
        async fleteCubicacionIndex(d, ok, err) {
            try {
                let r = await axios.get('flete/cubicacion?page=' + d.page, {params: d})
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fleteCubicacionStore(d, ok, err) {
            try {
                let r = await axios.post('flete/cubicacion', d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async fleteCubicacionUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('flete/cubicacion/' + id, d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async fleteCubicacionShow(id, ok, err) {
            try {
                let r = await axios.get('flete/cubicacion/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fleteCubicacionDestroy(id, ok, err) {
            try {
                let r = await axios.delete('flete/cubicacion/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/flete_cubicacion.js